import { Navigate, createBrowserRouter } from "react-router-dom";

import { AppShell } from "./layout/AppShell";
import { OverviewPage } from "./pages/OverviewPage";
import { SitePage } from "./pages/SitePage";
import { EconomicsPage } from "./pages/EconomicsPage";
import { TeamAskPage } from "./pages/TeamAskPage";
import { RiskPage } from "./pages/RiskPage";
import { MemoPage } from "./pages/MemoPage";
import { ParcelPage } from "./pages/ParcelPage";
import { ZoningPage } from "./pages/ZoningPage";
import { DemandPage } from "./pages/DemandPage";
import { CompsPage } from "./pages/CompsPage";
import { MarketSupportPage } from "./pages/MarketSupportPage";
import { PrecedentPage } from "./pages/PrecedentPage";
import { ConceptPage } from "./pages/ConceptPage";
import { ConceptProgramPage } from "./pages/ConceptProgramPage";
import { UnderwritingPage } from "./pages/UnderwritingPage";
import { FallbackPage } from "./pages/FallbackPage";
import { SourcesPage } from "./pages/SourcesPage";

export const PRIMARY_NAV_ITEMS = [
  { path: "/investment-case", label: "Investment Case" },
  { path: "/financials", label: "Financials" },
  { path: "/team-ask", label: "Team & Ask" },
  { path: "/market-support", label: "Market Support" }
] as const;

export const SUPPORT_NAV_ITEMS = [
  { path: "/site-zoning", label: "Site & Zoning" },
  { path: "/risks-mitigants", label: "Risks" },
  { path: "/sources-methodology", label: "Sources" }
] as const;

export const NAV_ITEMS = [...PRIMARY_NAV_ITEMS, ...SUPPORT_NAV_ITEMS] as const;

export const router = createBrowserRouter([
  {
    path: "/",
    element: <AppShell />,
    children: [
      { index: true, element: <Navigate to="/investment-case" replace /> },
      { path: "investment-case", element: <OverviewPage /> },
      { path: "financials", element: <EconomicsPage /> },
      { path: "team-ask", element: <TeamAskPage /> },
      { path: "site-zoning", element: <SitePage /> },
      { path: "market-support", element: <MarketSupportPage /> },
      { path: "concept-program", element: <ConceptProgramPage /> },
      { path: "risks-mitigants", element: <RiskPage /> },
      { path: "sources-methodology", element: <SourcesPage /> },
      { path: "site", element: <Navigate to="/site-zoning" replace /> },
      { path: "economics", element: <Navigate to="/financials" replace /> },
      { path: "risk", element: <Navigate to="/risks-mitigants" replace /> },
      { path: "concept", element: <ConceptPage /> },
      { path: "sources", element: <Navigate to="/sources-methodology" replace /> },
      { path: "memo", element: <MemoPage /> },
      { path: "parcel", element: <ParcelPage /> },
      { path: "zoning", element: <ZoningPage /> },
      { path: "demand", element: <DemandPage /> },
      { path: "comps", element: <CompsPage /> },
      { path: "precedent", element: <PrecedentPage /> },
      { path: "underwriting", element: <UnderwritingPage /> },
      { path: "fallback", element: <FallbackPage /> }
    ]
  }
]);
